import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery, Avatar } from '@mui/material';
import { green, blue } from '@mui/material/colors';
import { PageTitle } from '../../../layoutPages/components/PageTitle';
import { CourseTab } from '../menuTab';
import { HaveImage, Paragraph } from '../../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../../layoutPages/defaultSetting';
import { DottedList } from '../../../layoutPages/containers/DottedList';
import { MainCard } from '../../../layoutPages/components/MainCard';
import { MainCards } from '../../../layoutPages/containers/MainCards';
import { MainCardProps } from '../../../layoutPages/components/MainCard';
import { engMenuData } from '../../../data/SubjectMenu/engMenuData';

export function PageEngResources() {

    let point2Img: Array<MainCardProps> = [
        { src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point2a.jpg", onClick: () => { } },
        { src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point2b.jpg" },
        { src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point2b.jpg" },

    ];

    const isPc = useMediaQuery('(min-width:600px)');

    return (

        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <Grid item xs={11} sm={10} >
                <PageTitle title='Online Learning Resources' size='h3' />
                <CourseTab data={engMenuData} />
                <MainCard src="http://www.pkps.edu.hk/img/teachplan/eng/resources/top.jpg" noImgPopup={true} />
            </Grid>

            <Grid item xs={11} sm={7} justifyContent="start">
                <Typography variant="h5" align={"left"} >1. Reading Corner</Typography>
                <MainCard
                    sx={{ maxWidth: 480, mb: 4, mt: 2 }}

                    src="http://www.pkps.edu.hk/img/teachplan/eng/resources/point1.png" caption="Phonics Diagram (with voice recording)" onClick={() => window.open("http://www.pkps.edu.hk/eng/phonics/", '_blank', 'noopener,noreferrer')} />

                <MainCards data={[
                    {
                        caption: "Magic Word Bank (MWB) (with voice recording)",
                        src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point2b.jpg",
                        onClick: () => window.open("http://www.pkps.edu.hk/TV/magicwordsbank/", '_blank', 'noopener,noreferrer')
                    },
                    {
                        caption: "Online Readers (with link)",
                        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZ3CcPgIOjEbqrBYRE_yZe1Gp_K-g02nRJ6A&s",
                        onClick: () => window.open("https://www.getepic.com/sign-in", '_blank', 'noopener,noreferrer')
                    },
                ]} />

                <Typography variant="h5" align={"left"} sx={{ my: 2 }}>2. Self-Regulated Learning Corner(with link)</Typography>


                <Grid item xs={11} sm={5} justifyContent="start"></Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="top" spacing={2}>
                    <Grid item xs={11} sm={4} justifyContent="center">
                        <Paragraph title="Phonics Enhancement Program" titleSize='h6'
                            data={[
                                <MainCard
                                    sx={{ maxWidth: 330 }}
                                    src="http://www.pkps.edu.hk/img/teachplan/eng/resources/point3a.jpg" caption="Starfall.com"
                                    onClick={() => window.open("https://www.starfall.com/h/", '_blank', 'noopener,noreferrer')} />]}
                        />
                    </Grid>

                    <Grid item xs={11} sm={4} justifyContent="center">
                        <Paragraph title="Vocabulary Enhancement Program" titleSize='h6'
                            data={[
                                <MainCard
                                    sx={{ maxWidth: 330 }}
                                    src="http://www.pkps.edu.hk/img/teachplan/eng/resources/point3b.jpg" caption="Vocabulary.com"
                                    onClick={() => window.open("https://www.vocabulary.com/", '_blank', 'noopener,noreferrer')} />]}
                        />
                    </Grid>

                    <Grid item xs={11} sm={4} justifyContent="center">

                        <Paragraph title="Grammar Enhancement Program" titleSize='h6'
                            data={[
                                <MainCard
                                    sx={{ maxWidth: 330 }}
                                    src="http://www.pkps.edu.hk/img/teachplan/eng/resources/point3c.jpg" caption="Road to Grammar"
                                    onClick={() => window.open("http://www.roadtogrammar.com/", '_blank', 'noopener,noreferrer')} />]}
                        />
                    </Grid>
                </Grid>

                <Typography variant="h6" align={"left"} sx={{ my: 2 , color: blue[500]}}> Online Dictionary References</Typography>


                <MainCards data={[
                    {
                        caption: "Electronic dictionary references",
                        src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point3e.jpg",
                        onClick: () => window.open("https://dictionary.cambridge.org/zht/", '_blank', 'noopener,noreferrer')
                    },
                    {
                        caption: "Electronic dictionary references",
                        src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point3f.jpg",
                        onClick: () => window.open("http://www.pkps.edu.hk/newhtml/news/0908/gp/index.htm", '_blank', 'noopener,noreferrer')
                    },
                ]} />

                <MainCards data={[
                    {
                        caption: "Electronic dictionary references",
                        src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point3g.jpg",
                        onClick: () => window.open("https://www.ldoceonline.com/dictionary", '_blank', 'noopener,noreferrer')
                    },
                    {
                        caption: "Electronic dictionary references",
                        src: "http://www.pkps.edu.hk/img/teachplan/eng/resources/point3h.jpg",
                        onClick: () => window.open("https://www.thesaurus.com/", '_blank', 'noopener,noreferrer')
                    },
                ]} />

<Paragraph title="Other Helpful Website(s)" titleSize='h6'
                            data={[
                                <MainCard
                                    sx={{ maxWidth: 330 }}
                                    src="https://dmi.lk/wp/wp-content/uploads/2024/02/british-council-purple-edited.webp" caption="British Council"
                                    onClick={() => window.open("https://learnenglishkids.britishcouncil.org/", '_blank', 'noopener,noreferrer')} />]}
                        />


            </Grid>

        </Grid>


    );
}